// extracted by mini-css-extract-plugin
export default {"multiAssetRow":"transactionHistory-module__multiAssetRow__3Th0s","amount":"transactionHistory-module__amount__PsqM0","quantity":"transactionHistory-module__quantity__0o5WA"};